import React, { useEffect, useState } from "react";
import { generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, getUserType } from "./../../utils";
import { proxy } from '../../process/api';
import ReportOptions from "../ReportOptions";
import { useNavigate } from "react-router-dom";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";

import ProcessLoader from "../ProcessLoader";
const AB01 = () => {

  const userType = getUserType();
  const [pageTitle, setPageTitle] = useState('');
  const [showProcessLoader, setShowProcessLoader] = useState(false);
  const [showResetProcess, setshowResetProcess] = useState(false);
  const [abmList, setABMList] = useState([]);
  const navigate = useNavigate();

  const div_data = JSON.parse(localStorage.getItem('div_data'));
  const year_data = JSON.parse(localStorage.getItem('year_data'));
  const month_data = JSON.parse(localStorage.getItem('month_data'));
  const depo_data = JSON.parse(localStorage.getItem('depo_data')).data.filter(item => item.value !== 0);



  const seleted_div_value = localStorage.getItem('selected_div');


  const [showOptions, setShowOptions] = useState(true);
  const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
  const [SelectedYear, setSelectedYear] = useState(
    () => localStorage.getItem('abmSelectedYear') ?? year_data.data[0].value
  );

  const [SelectedDepo, setSelectedDepo] = useState(
    depo_data[0].value
  );

  const [SelectedStartMonth, setSelectedStartMonth] = useState(
    () => localStorage.getItem('abmSelectedMonth') ?? month_data.data[0].value
  );
  const [showHQLoading, setHQLoading] = useState(false);

  const divData = JSON.parse(localStorage.getItem("div_data"))?.data || [];
  const depoData = JSON.parse(localStorage.getItem("depo_data"))?.data || [];

  const divMap = Object.fromEntries(divData.map(d => [String(d.value), d.name]));
  const depoMap = Object.fromEntries(depoData.map(d => [String(d.value), d.name]));
  const [SelectecReportType, setSelectecReportType] = useState(1);




  const exportData = (abmList || []).map((item, index) => {
    const draftId = item?.draft_id;
    const status = item?.draft_status ?? "";

    const monthCodeStr = String(item?.mnth_code ?? "");
    const mm = monthCodeStr.length >= 2 ? monthCodeStr.slice(-2) : "";
    const yyyy =
      item?.myear ??
      (monthCodeStr.length >= 4 ? monthCodeStr.slice(0, 4) : "");

    const reportMonth = mm && yyyy ? `${mm}/${yyyy}` : "-";
    const entryDate = item?.entry_date ?? "-";

    const loginName =
      item?.login_name && item.login_name.trim() !== ""
        ? item.login_name
        : "-";

    const divName = divMap[String(item?.div_code)] || "-";
    const branchName = depoMap[String(item?.depo_code)] || "-";

    return {
      SrNo: index + 1,
      CreationDate: entryDate,
      MonthCode: item?.mnth_code ?? "-",
      CreatedBy: `${loginName} - ${item?.emp_code ?? "-"} - ${item?.ter_name ?? "-"}`,
      Division: divName,
      Branch: branchName,
      Status: status || "-"
    };
  });



  const handExport = () => {
    const columns = [
      "SrNo",
      "CreationDate",
      "MonthCode",
      "CreatedBy",
      "Division",
      "Branch",
      "Status"
    ];


    const naturalMonths = [
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER"
    ];

    const aristoToNaturalMonth = [10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    const formattedMonthCode = String(naturalMonths[aristoToNaturalMonth[SelectedStartMonth - 1] - 1]).padStart(2, 0);

    var reportJson = {};
    const contextYear =
      SelectedStartMonth > 3
        ? parseInt(SelectedYear, 10) + 1
        : parseInt(SelectedYear, 10);

    reportJson.fileName = "ABM Report - " + formattedMonthCode + "-" + contextYear + " - " + JSON.parse(localStorage.getItem('div_data')).data.find(depos => depos.value == SelectedDiv).name + ".xlsx";
    reportJson.title = "ABM Report - " + JSON.parse(localStorage.getItem('div_data')).data.find(depos => depos.value == SelectedDiv).name + " - " + formattedMonthCode + " - " + contextYear;
    reportJson.author = "Aristo Pharma";
    reportJson.sheets = [
      {
        name: "Sheet 1",
        data: []
      }
    ]

    const headerFormatted = columns.map(key => getHeaderColNames(key));
    reportJson.sheets[0].data.push({
      backgroundColor: "#0043a9",
      fontColor: "#FFFFFF",
      fontSize: 13,
      bold: true,
      values: headerFormatted
    });
    const backgroundColors = excelColorCodes;
    exportData.forEach(item => {
      const row = {
        backgroundColor: backgroundColors[item.color] || "", // Default to white if undefined
        fontColor: item.color === 2 ? "#333333" : "#333333",
        fontSize: 12,
        bold: false,
        values: columns.map(col => item[col])
      };
      reportJson.sheets[0].data.push(row);
    });

    generateExcel(reportJson).catch(console.error);

  }
  const handleEdit = (item) => { };
  const handleOpen = (item) => { };

  const loadABMList = async () => {
    let abmAPIResponse = {};


    localStorage.setItem("abmSelectedMonth", SelectedStartMonth);
    localStorage.setItem("abmSelectedYear", SelectedYear);

     var url = "";
    if (SelectecReportType == 1 && userType == 4) {
      url = "/api/mis/abm/draftreport/" + `${SelectedStartMonth}/${SelectedYear}`;
    } else if (SelectecReportType == 1 && userType != 4) {
      url = "/api/mis/abm/draftlist/" + `${SelectedDiv}/${SelectedStartMonth}/${SelectedYear}`;
    } else if (SelectecReportType == 2 && userType == 4) {
      url = "/api/mis/abm/draftreport/" + `${SelectedStartMonth}/${SelectedYear}`;
    } else if (SelectecReportType == 2 && userType != 4) {
      url = "/api/mis/abm/report/missing/" + `${SelectedYear}/${SelectedDiv}/${SelectedStartMonth}`;
    }


     abmAPIResponse = await proxy(
       url,
        {},
        "get"
      );

    console.log(abmAPIResponse);
    setABMList(abmAPIResponse);
    setShowProcessLoader(false);
    setShowOptions(false);
  };
  const handleReset = async (draftId) => {

    if (!window.confirm("Are you sure you want to reset this report?")) {
      return;
    }

    try {
      setShowProcessLoader(true);

      const response = await proxy(
        `/api/mis/abm/report/deletefinaldraft/${draftId}`,
        {},
        "delete"
      );

      if (response?.status === "SUCCESS") {
        await loadABMList();
      }
    } catch (error) {
      console.error("Reset failed:", error);
    } finally {
      setShowProcessLoader(false);
    }
  };



  const loadHQList = async (year, div, branch) => {
    setHQLoading(true);
    const hqAPIResponse = await proxy(`/api/mis/hqlist/${year}/${div}/${branch}`, {}, "get");

  } 
  const handleBranchChange = async (newValue) => {
    setSelectedDepo(newValue);
    loadHQList(SelectedYear, SelectedDiv, newValue);

  }




  useEffect(() => {


    transformNavDataForLabels("AB01").then(title => {
      setPageTitle(title);
    });

  }, []);

  return (
    <>

      <div class="main-content">

        {showProcessLoader && <ProcessLoader />}
        {showOptions ?
          <ReportOptions title={pageTitle} >

            <div className="report-option-wrapper">
              <div className="report-option-row">
                <div className="report-option-item">
                  <label>Division</label>
                  <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); }} />
                </div>

                {userType == 4 &&
                  <div className="report-option-item ml-20">
                    <label>Branch</label>
                    <DropDownControl data={depo_data} id="report_branch_list" name="report_branch_list"

                      onChange={(newBranch) => { handleBranchChange(newBranch); }}
                    />
                  </div>
                }


              </div>

              <div className="report-option-row">
                <div className="report-option-item ">
                  <label>Mkt&nbsp;Year</label>
                  <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" selectedValue={SelectedYear} onChange={(newYear) => { setSelectedYear(newYear) }} />

                </div>

                <div className="report-option-item ml-20">
                  <label>For&nbsp;Month</label>
                  <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                </div>




              </div>
              {userType != 4 && <>
              <div className="report-option-row">
                <div className="report-option-item ">
                  <input type="radio" name="bi05_type" className="mr-2" checked={SelectecReportType == 1} onChange={(val) => { setSelectecReportType(1) }} />
                  <label>Report Submitted</label>


                </div>


                <div className="report-option-item ">
                  <input type="radio" name="bi05_type" className="mr-2" checked={SelectecReportType == 2} onChange={(val) => { setSelectecReportType(2) }} />
                  <label>Report Pending</label>

                </div>

              </div>
              </>}


              <div className="report-option-action-row">
                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                <button onClick={loadABMList} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SEARCH</button>
              </div>
            </div>
          </ReportOptions>
          :
          <>
            <div className="row">
              <div className="col-12">
                <div className="card report-card" style={{ width: "min-content" }}>
                  <div className="card-title report-card-title">{pageTitle}
                    {userType == 4 &&
                      <button className="btn btn-outline btn-sm  mr-10 fw-500" onClick={() => navigate("/abm-report-01-init")}>CREATE NEW</button>
                    }

                    <button className="btn btn-outline btn-sm  mr-10 fw-500 " onClick={handExport}>EXPORT</button>
                    <button className="btn btn-outline btn-sm  mr-10 fw-500 ml-2" onClick={() => window.location.reload()}>BACK</button>
                  </div>
                  <div className="card-body">

                    <table className=" table table-striped " data-fixedHeader="true" cellspacing="0" id="reportDataTable" data-dom='plftrip' data-provide="datatables"  >

                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Creation Date</th>
                          <th>Month Code</th>
                          <th>Created By</th>
                          <th>Div</th>
                          <th>Branch</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {(!abmList || abmList.length === 0) ? (
                          <tr>
                            <td colSpan={8} className="text-center text-muted py-3">
                              No records found
                            </td>
                          </tr>
                        ) : (
                          abmList.map((item, index) => {
                            const draftId = item?.draft_id;
                            const status = item?.draft_status ?? "";


                            const monthCodeStr = String(item?.mnth_code ?? "");
                            const mm = monthCodeStr.length >= 2 ? monthCodeStr.slice(-2) : "";
                            const yyyy =
                              item?.myear ??
                              (monthCodeStr.length >= 4 ? monthCodeStr.slice(0, 4) : "");

                            const reportMonth = mm && yyyy ? `${mm}/${yyyy}` : "-";
                            const entryDate = item?.entry_date ?? "-";

                            const loginName =
                              item?.login_name && item.login_name.trim() !== ""
                                ? item.login_name
                                : "-";

                            const canEdit = status === "Draft";

                            return (
                              <tr key={draftId ?? index}>
                                <td>{index + 1}</td>
                                <td>{entryDate}</td>
                                <td>{item.mnth_code}</td>

                                <td>{loginName} - {item.emp_code} - {item.ter_name}</td>
                                <td>{
                                  JSON.parse(localStorage.getItem('div_data')).data.find(depos => depos.value == item.div_code).name
                                }

                                </td>
                                <td>{


                                  JSON.parse(localStorage.getItem('depo_data')).data.find(depos => depos.value == item.depo_code).name

                                }</td>
                                <td>
                                  <span
                                    className={`badge ${status === "FINAL" ? "bg-success" : "bg-secondary"
                                      }`}
                                  >
                                    {status || "-"}
                                  </span>
                                </td>
                                <td>
                                  {status === "Draft" && draftId && userType == 4 ? (
                                    <a
                                      className="btn btn-sm btn-primary me-2"
                                      href={`/abm-report-01-edit/${draftId}`}
                                    >
                                      Edit
                                    </a>
                                  ) : null}


                                  {draftId ? (
                                    <a
                                      className="btn btn-sm btn-outline-secondary ml-10"
                                      href={`/abm-report-01-view/${draftId}`}
                                    >
                                      Open
                                    </a>
                                  ) : (
                                    <button className="btn btn-sm btn-outline-secondary ml-10" disabled>
                                      Open
                                    </button>
                                  )}
                                  {status?.toUpperCase() === "FINAL" && draftId && userType == 9 ? (
                                    <button
                                      className="btn btn-sm btn-primary me-2 ml-2"
                                      onClick={() => handleReset(draftId)}
                                    >
                                      Reset
                                    </button>
                                  ) : null}

                                </td>

                              </tr>
                            );
                          })
                        )}
                      </tbody>



                    </table>

                  </div>

                </div>
              </div>
            </div>
          </>}
      </div>
    </>
  );
}

export default AB01;